import { Link, useLocation, useHistory} from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import styles from "../index.module.css";
import stylesBase from "../base.module.css";
export default function MarketingHeader() {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  let language = i18n.language || 'en'
  const [activeTab, setActiveTab] = useState(0)
  const [activeLang, setActiveLang] = useState(0)

  const changeLanguage = (language) => {
  i18n.changeLanguage(language, () => {
    Cookies.set('selectedLanguage', language, { expires: 365 });
    const currentPath = location.pathname;
    const newPath = currentPath.replace(/^\/(en|ja|vi|ko)/, `/${language}`);
    if (currentPath !== newPath) {
      history.replace(newPath);
    }
  });
};
const handleClickTab = (index) => {
  setActiveTab(index)
}
const handleActiveLang = (index) => {
  setActiveLang(index)
}
  useEffect(() => {
    const savedLang = Cookies.get('selectedLanguage');
    if(savedLang && i18n.language !== savedLang){
      i18n.changeLanguage(savedLang)
      }
  })
  useEffect(() => {
    switch (language) {
      case 'en': 
        handleActiveLang(0);
        break;
      case 'ja': 
        handleActiveLang(1);
        break;
      case 'vi': 
        handleActiveLang(2);
        break;
      case 'ko': 
        handleActiveLang(3);
        break;
      default:
        break;
    }
  }, [language]);


  return (
      <>
      <div className={styles.topHeader}>
        <div className='container-fluid'>
                    <div className='d-flex row align-items-center justify-content-end'>
                              <button className={`${styles.btnEn} mr-3`}style={{opacity: activeLang === 0 ? 1 : .3}} onClick={()=>{
                                handleActiveLang(0)
                                changeLanguage('en')
                                }}></button>                
                              <button className={`${styles.btnJa} mr-3`}style={{opacity: activeLang === 1 ? 1 : .3}} onClick={()=>{
                                handleActiveLang(1)
                                changeLanguage('ja')
                                }}></button>  
                              <button className={`${styles.btnVie} mr-3`}style={{opacity: activeLang === 2 ? 1 : .3}} onClick={()=>{
                                handleActiveLang(2)
                                changeLanguage('vi')
                                }}></button> 
                              <button className={`${styles.btnKor} mr-3`}style={{opacity: activeLang === 3 ? 1 : .3}} onClick={()=>{
                                handleActiveLang(3)
                                changeLanguage('ko')
                                }}></button> 
                    </div>
                </div>
            </div>
           <div className={styles.headerContainer}>
            <div className={styles.header2}>
              <div className={styles.headerPC2}>
                <div className={styles.headerLogo}>
                  <div className="container">
                    <div className="row">
                      <div className="col-md-12">
                        <Link to="/">
                          <img
                            src="/webp/azlogo.webp"
                            alt="logo"
                          />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
           {/* <div className={stylesBase.isSticky}> */}
           <div className="container">
            <div className={styles.header} style={{backgroundColor: "#482979"}}>
              <div  className={styles.headerPC}>
                   <div className={`${styles.headerNavbarList} mb-0 justify-content-start`}>
                   <div className={styles.headerNavbarItem}>
                   <div className={styles.headerLogo}>
                  <div className="container">
                    <div className="row">
                      <div className="col-md-12">
                        <Link to={`/marketing/${language}`}>
                          <img
                             src="https://azumayavietnam.com/webp/azlogo.webp"
                             alt="logo"
                          />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                      </div>
                    </div>      
                     <div className={`${styles.headerNavbarList} mb-0`}>
                        <div className={styles.headerNavbarItem} onClick={() => handleClickTab(0)} style={{backgroundColor: activeTab === 0 ? "#281349" : "transparent"}}>
                            <Link className={styles.headerNavbarLink2} style={{width: 100}} to={`/marketing/${language}`}>
                              Dashboard
                            </Link>
                          </div>
            
                          <div className={styles.headerNavbarItem} onClick={() => handleClickTab(1)} style={{backgroundColor: activeTab === 1 ? "#281349" : "transparent"}}>
                            <Link className={styles.headerNavbarLink2} style={{width: 100}} to={`/marketing/${language}/ga4-vn`}>
                              GA4-VN
                            </Link>
                          </div>

                           <div className={styles.headerNavbarItem} onClick={() => handleClickTab(2)} style={{backgroundColor: activeTab === 2 ? "#281349" : "transparent"}}>
                            <Link className={styles.headerNavbarLink2} style={{width: 100}} to={`/marketing/${language}/ga4-cam`}>
                              GA4-CAM
                            </Link>
                          </div>

                          <div className={styles.headerNavbarItem} onClick={() => handleClickTab(3)} style={{backgroundColor: activeTab === 3 ? "#281349" : "transparent"}}>
                            <Link className={styles.headerNavbarLink2} style={{width:110}}  to={`/marketing/${language}/google-ads`}>
                              Google Ads
                            </Link>
                          </div>

                          <div className={styles.headerNavbarItem} onClick={() => handleClickTab(4)} style={{backgroundColor: activeTab === 4 ? "#281349" : "transparent"}}>
                            <Link className={styles.headerNavbarLink2} style={{width: 100}} to={`/marketing/${language}/meta-ads`}>
                              Meta
                            </Link>
                          </div>
                          
                           <div className={styles.headerNavbarItem} onClick={() => handleClickTab(5)} style={{backgroundColor: activeTab === 5 ? "#482979" : "transparent"}}>
                            <Link className={styles.headerNavbarLink2} style={{width: 100}} to={`/marketing/${language}/line`}>
                             Line
                            </Link>
                          </div>

                            <div className={styles.headerNavbarItem} onClick={() => handleClickTab(6)} style={{backgroundColor: activeTab === 6 ? "#482979" : "transparent"}}>
                            <Link className={styles.headerNavbarLink2} style={{width: 150}} to={`/marketing/${language}/market-analytic`}>
                             Market Analytic
                            </Link>
                            </div>

                            <div className={styles.headerNavbarItem} onClick={() => handleClickTab(7)} style={{backgroundColor: activeTab === 7 ? "#482979" : "transparent"}}>
                            <Link className={styles.headerNavbarLink2} style={{width: 100}} to={`/marketing/${language}/compare`}>
                             Compare
                            </Link>
                            </div>
                            
                            <div className={styles.headerNavbarItem} onClick={() => handleClickTab(8)} style={{backgroundColor: activeTab === 8 ? "#482979" : "transparent"}}>
                            <Link className={styles.headerNavbarLink2} style={{width: 100}} to={`/marketing/${language}/seo`}>
                             SEO
                            </Link>
                            </div>

                            {/* <div className={styles.headerNavbarItem} onClick={() => handleClickTab(9)} style={{backgroundColor: activeTab === 9 ? "#482979" : "transparent"}}>
                            <Link className={styles.headerNavbarLink2} style={{width: 130}} to={`/marketing/${language}/google-maps-reviews`}>
                             Maps Reviews
                            </Link>
                            </div> */}
                             
                        </div>
                        </div>
                  </div>
                {/* </div> */}
                </div>
  </>
);
}